import { render } from "./Breadcrumb.vue?vue&type=template&id=1821c1fb&scoped=true&ts=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=ts"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts"

import "./Breadcrumb.vue?vue&type=style&index=0&id=1821c1fb&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1821c1fb"]])

export default __exports__